'use strict';

const _ = require('underscore');
const i18n = require('i18next');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const TagActionCreator = require('system/domain/action/tag');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const TagStore = require('system/domain/repository/tag');
const TagModel = require('system/domain/entity/tag');
const TagCreateView = require('system/ui/view/modal/tag-create');
const TagEditModalView = require('system/ui/view/modal/tag-edit');
const TagListViewTemplate = require('system/ui/template/tag/list.hbs');
const TagViewTemplate = require('system/ui/template/tag/item.hbs');
const NoCategoryViewTemplate = require('system/ui/template/tag/no-category-item.hbs');
const CategoryViewTemplate = require('system/ui/template/tag/category-item.hbs');
const TagDeleteConfirmTemplate = require('system/ui/template/tag/delete-confirm.hbs');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');

const TagView = Mn.View.extend({
    model: TagModel,
    tagName: 'li',
    className: 'list-item tag-list-item',
    template: TagViewTemplate,
    ui: {
        edit: '.edit',
        delete: '.delete',
        taggedNodes: '.tagged-nodes'

    },
    events: {
        'click @ui.edit': 'edit',
        'click @ui.delete': 'delete',
        'click @ui.taggedNodes': 'showTaggedNodes',
        'click': 'toggle'
    },
    modelEvents: {
        'change': 'render',
        'remove': 'destroy'
    },

    initialize: function(options) {
        this._context = options.context;
        this._edit = options.edit;
        this._diagramContext = options.diagramContext;
        if(this._diagramContext) {
            this.listenTo(
                ElementRepository.getNodes({
                    context: this._diagramContext
                }),
                'change:tags', this.render
            );
        }
    },

    serializeData: function() {
        const j = this.model.toJSON();
        j.edit = this._edit;

        // Diagram 内で表示されている場合はタグの付いているノード数と詳細を表示する
        if(this._diagramContext) {
            this._nodes = null;
            const diagram = DiagramRepository.getDiagrams({
                context: this._diagramContext
            }).get(this._diagramContext.diagramId);
            j.nodes = ElementRepository.getNodes({
                context: this._diagramContext
            })
                .chain()
                .filter(function(m){ return diagram.hasNode(m); })
                .filter(function(m){
                    return _.contains(m.get('tags'), this.model.id);
                }, this)
                .value();
            j.hasNode = j.nodes.length > 0;
            j.nodeNum = j.nodes.length;
        }

        return j;
    },

    onRender: function() {
        if(this.model.get('deleted')) {
            this.destroy();
            return;
        }
        if(this.model.selected()) {
            this.activate();
        } else {
            this.deactivate();
        }
        this.$el.draggable({
            handle: '.move',
            revert: true,
            revertDuration: 200,
            axis: 'y',
            zIndex: 10000
        });
        $(this.el).data('backbone-view', this);
        return this;
    },

    showTaggedNodes: function(evt) {
        const name = this.model.get('name');
        const id = this.model.id.substring(0, 6);
        this.getOption('channel').request('search',
            `tag:"${name}"(#${id})`);
        evt.stopPropagation();
    },

    edit: function(evt){
        const modal = new TagEditModalView({
            original: this.model,
            context: this._context
        });
        $('#modal-container').append(modal.render().el);
        modal.show();
        evt.stopPropagation();
    },

    delete: function(evt) {
        const template = $(TagDeleteConfirmTemplate());
        this.ui.delete.popover({
            html: true,
            placement: 'left',
            title: i18n.t('view:tag.delete-confirm.title'),
            trigger: 'focus',
            content: template
        });
        this.ui.delete.popover('show');
        const self = this;
        template.find('button.delete').click(function() {
            self.ui.delete.popover('destroy');
            TagActionCreator.deleteTag(
                self._context.projectId, self.model.id
            );
        });
        template.find('button.cancel').click(function() {
            self.ui.delete.popover('destroy');
        });
        template.click(function(evt) {
            evt.stopPropagation();
        });
        evt.stopPropagation();
    },

    activate: function() {
        this.$el.addClass('is-active');
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
    },

    toggle: function() {
        TagActionCreator.toggleTag({
            context: this._context,
            tag: {id: this.model.id}
        });
    }
});

const TagCategoryView = Mn.CompositeView.extend({
    className: 'tag-category',
    tagName: 'li',
    childView: TagView,
    childViewContainer: '.tag-list',
    template: CategoryViewTemplate,
    ui: {
        title: '.tag-category-header',
        edit: '.edit',
        delete: '.delete'
    },
    events: {
        'click @ui.edit': 'edit',
        'click @ui.delete': 'delete',
        'click @ui.title': 'toggle'
    },
    modelEvents: {
        'change': 'render',
        'remove': 'destroy'
    },
    childViewOptions: function() {
        return {
            context: this._context,
            edit: this._edit,
            diagramContext: this._diagramContext
        };
    },

    initialize: function(options) {
        this._context = options.context;
        this._edit = options.edit;
        this._diagramContext = options.diagramContext;
        this.collection = new Backbone.Collection(
            TagStore.getTags({context: this._context})
                .where({category: this.model.id}));
    },

    onRender: function() {
        const self = this;
        if(this.model.get('deleted')) {
            this.destroy();
            return;
        }

        this.$el.droppable({
            hoverClass: 'is-highlighted',
            drop: function(event, ui) {
                const model = $(ui.draggable).data('backbone-view').model;
                TagActionCreator.categorizeTag(
                    self._context.projectId,
                    model.id,
                    self.model.id
                );
            }
        });
    },

    serializeData: function() {
        const j = this.model.toJSON();
        j.edit = this._edit;
        return j;
    },

    edit: function(evt){
        const modal = new TagEditModalView({
            context: this._context,
            original: this.model,
            isCategory: true
        });
        $('#modal-container').append(modal.render().el);
        modal.show();
        evt.stopPropagation();
    },

    toggle: function() {
        if(this.collection.filter(function(t){
                return t.selected();
            }).length == this.collection.length) {
            this.collection.each(function(t) {
                t.deselect();
            });
        } else {
            this.collection.each(function(t) {
                t.select();
            });
        }
    },

    delete: function(evt) {
        const template = $(TagDeleteConfirmTemplate());
        this.ui.delete.popover({
            html: true,
            placement: 'left',
            title: i18n.t('view:tag-category.delete-confirm.title'),
            trigger: 'focus',
            content: template
        });
        this.ui.delete.popover('show');
        const self = this;
        template.find('button.delete').click(function() {
            self.ui.delete.popover('destroy');
            TagActionCreator.deleteCategory(
                self._context.projectId, self.model.id
            );
        });
        template.find('button.cancel').click(function() {
            self.ui.delete.popover('destroy');
        });
        template.click(function(evt) {
            evt.stopPropagation();
        });
        evt.stopPropagation();
    }
});

const TagsView = Mn.CompositeView.extend({
    template: NoCategoryViewTemplate,
    childView: TagView,
    childViewContainer: '.tags',
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            edit: this.getOption('edit'),
            channel: this.getOption('channel'),
            diagramContext: this.getOption('diagramContext')
        };
    },
    ui: {
        title: '.tag-nocategory-header'
    },
    events: {
        'click @ui.title': 'toggle'
    },

    initialize: function(options) {
        this._context = options.context;
        this._edit = options.edit;
        this._diagramContext = options.diagramContext;
    },

    onRender: function() {
        const context = this._context;
        this.$el.droppable({
            hoverClass: 'is-highlighted',
            drop: function(event, ui) {
                const model = $(ui.draggable).data('backbone-view').model;
                TagActionCreator.categorizeTag(
                    context.projectId,
                    model.id,
                    null
                );
            }
        });
    },

    toggle: function() {
        if(this.collection.filter(function(t){
                return t.selected();
            }).length == this.collection.length) {
            this.collection.each(function(t) {
                t.deselect();
            });
        } else {
            this.collection.each(function(t) {
                t.select();
            });
        }
    }
});

const TagCategoriesView = Mn.CollectionView.extend({
    className: 'tag-categories list-item',
    childView: TagCategoryView,
    childViewOptions: function() {
        return {
            context: this._context,
            edit: this._edit,
            diagramContext: this._diagramContext
        };
    },

    initialize: function(options) {
        this._context = options.context;
        this._edit = options.edit;
        this._diagramContext = options.diagramContext;
    },

    addChild: function(item, View, index){
        if (!item.get('deleted')) {
            Mn.CollectionView.prototype.addChild.apply(this, arguments);
        }
    }
});

module.exports = Mn.View.extend({
    className: 'tags',
    template: TagListViewTemplate,
    ui: {
        add: '.new-tag',
        edit: '.edit',
        done: '.done'
    },
    events: {
        'click @ui.add': 'add',
        'click @ui.edit': 'edit',
        'click @ui.done': 'done'
    },
    regions: {
        tags: '.tag-list',
        categories: '.category-list'
    },

    /**
     * タグを表示するための View。
     *
     * @constructs
     */
    initialize: function(params) {
        this._editable = params.editable;
        this._context = params.context;
        // diagram が渡ってきた場合は diagram 内で表示されている
        this._diagramContext = params.diagramContext;

        this._tags = TagStore.getTags({context: this._context});
        this._categories = TagStore.getCategories(
            {context: this._context});
        this._edit = false;
        this.listenTo(this._tags, 'add', this.render);
        this.listenTo(this._tags, 'change:category', this.render);
        this.listenTo(this._categories, 'add', this.render);
    },

    serializeData: function() {
        return {
            editable: this._editable,
            edit: this._edit
        };
    },

    onRender: function() {
        const context = this._context;
        this.showChildView('tags', new TagsView({
            collection: new Backbone.Collection(
                this._tags.filter(function(item) {
                    if (item.get('deleted')) {
                        return false;
                    }
                    if (item.get('category') &&
                        TagStore.getCategories({
                            context: context
                        }).get(item.get('category'))) {
                        return false;
                    }
                    return true;
                })),
            context: this._context,
            channel: this.getOption('channel'),
            edit: this._edit,
            diagramContext: this._diagramContext
        }));
        this.showChildView('categories', new TagCategoriesView({
            collection: this._categories,
            context: this._context,
            edit: this._edit,
            diagramContext: this._diagramContext
        }));
    },

    add: function() {
        const tagCreateView = new TagCreateView({
            collection: this.collection,
            context: this._context
        });
        $('#modal-container').append(tagCreateView.render().el);
        tagCreateView.show();
    },

    edit: function() {
        this._edit = true;
        this.render();
    },

    done: function() {
        this._edit = false;
        this.render();
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/tag/list.js